import { isValidElement as e } from "react";
//#region src/utils/analytics/getTrackingLabelFromNode.ts
var t = (n) => {
	if (n != null && typeof n != "boolean") {
		if (typeof n == "string" || typeof n == "number" || typeof n == "bigint") return String(n);
		if (Array.isArray(n)) {
			let e = n.map(t).filter((e) => typeof e == "string" && e.length > 0);
			return e.length > 0 ? e.join(" ") : void 0;
		}
		if (e(n)) {
			let e = t(n.props.children);
			if (e) return e;
			if (typeof n.props.id == "string" && n.props.id.length > 0) return n.props.id;
		}
	}
};
//#endregion
export { t as getTrackingLabelFromNode };

//# sourceMappingURL=getTrackingLabelFromNode.js.map